import React from "react";
import "../../assets/css/IndustryServe.css";

import yeastimg from "../../assets/images/yeasts.webp";
import enzymeimg from "../../assets/images/enzymes.webp";
import chemicalimg from "../../assets/images/chemicals.webp";

function IndustryServe() {
  const products = [
    {
      img: yeastimg,
      title: "Industrial Yeast",
      desc: "Premium yeast solutions for efficient distillery operations.",
    },
    {
      img: enzymeimg,
      title: "Enzymes",
      desc: "Advanced enzyme solutions for improved process efficiency.",
    },
    {
      img: chemicalimg,
      title: "Industrial Chemicals",
      desc: "Reliable chemical solutions for distilleries and process industries.",
    },
  ];

  return (
    <section className="industry-section">
      <div className="container">
        {/* Heading */}
        <div className="section-heading text-center">
          <span className="section-tag">OUR PRODUCT RANGE</span>

          <h2 className="section-title">Distillery Industry Solutions</h2>

          <p className="section-subtitle">
            Supplying premium Yeast, Enzymes and Chemicals to enhance
            productivity, efficiency and operational excellence.
          </p>
        </div>

        {/* Cards */}
        <div className="row justify-content-center g-4">
          {products.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="product-card">
                <div className="product-image">
                  <img src={item.img} alt={item.title} />
                </div>

                <h4>{item.title}</h4>

                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustryServe;
